import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './ui-screen-reader-only.css?inline';

const CName = 'ui-screen-reader-only';

@customElement(CName)
export class UiScreenReaderOnly extends LitElement {
  static readonly styles = unsafeCSS(styles);

  @property({ type: String, reflect: true }) role: string | null = null;

  render() {
    return html`<div class="visually-hidden"><slot></slot></div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UiScreenReaderOnly;
  }
}
